export default function Footer(){
    return(
        <div>
            <footer className="w-screen py-6 px-4 sm:px-6 lg:px-8 mx-auto border-t border-slate-900/10">
                <div className="text-center">
                    {/*<img className="w-80 h-80 mx-auto" src={BioGlimmerLOGO} alt=""/>*/}
                    <div className="mt-3 flex-none text-xl font-semibold text-black">
                        BioGlimmer @ iGEM
                    </div>
                    <div className="mt-3 text-gray-600">
                        <span>The source code is available at </span>
                        <span className="hover:text-blue-700 transition-all duration-300">
                                <a
                                    href="https://gitlab.igem.org/2024/stockholm"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dec-n bold color-b"
                                >
                                    https://gitlab.igem.org/2024/stockholm
                                </a>
                            </span>
                    </div>
                    <div className="mt-3 text-gray-600">
                        <span>This website is licensed under </span>
                        <span className="hover:text-blue-700 transition-all duration-300">
                                <a
                                    href="https://creativecommons.org/licenses/by/4.0/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dec-n bold color-b"
                                >
                                    Creative Commons Attribution 4.0
                                </a>
                            </span>
                    </div>
                </div>
            </footer>
        </div>
    )
}